import React, { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import "./ModalListadoImportados.css";
import { datosMedicamentosImportados } from "../../../firebase/firebase-methods";
import { ModalLoading } from "./ModalLoading";

export const ModalListadoImportados = ({
  showModalListadoImportados,
  handleCloseModalListadoImportados,
}) => {
  const [medicamentosImportados, setMedicamentosImportados] = useState([]);
  const [showModalLoading, setShowModalLoading] = useState(true);
  useEffect(() => {
    const getMedicamentosImportados = async () => {
      try {
        const response = await datosMedicamentosImportados();
        if (response.length > 0) {
          setMedicamentosImportados(response);
          setShowModalLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getMedicamentosImportados();
  }, []);
  if (showModalLoading) {
    return <ModalLoading showModalLoading={showModalLoading} />;
  } else {
    return (
      <Modal
        show={showModalListadoImportados}
        onHide={handleCloseModalListadoImportados}
        size="lg"
      >
        <Modal.Header className="header-modal">
          <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10  text-start">
            <Modal.Title style={{ fontSize: "1.2rem" }}>
              Listado de últimos medicamentos importados
            </Modal.Title>
          </div>
          <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 text-end">
            <FontAwesomeIcon
              icon={faXmark}
              size="xl"
              onClick={handleCloseModalListadoImportados}
              className="icon-ficha"
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="container text-start">
            <div className="row ">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 ">
                <Table responsive>
                  <thead className="cont-import">
                    <tr>
                      <th scope="col" className="titulos">
                        PRINCIPIO ACTIVO
                      </th>
                      <th scope="col" className="titulos">
                        NOMBRE MEDICAMENTO
                      </th>
                      <th scope="col" className="titulos">
                        CONCENTRACIÓN
                      </th>
                      <th scope="col" className="titulos">
                        CONTENIDO
                      </th>
                    </tr>
                  </thead>
                  {medicamentosImportados.map((medicamento, index) => (
                    <tbody key={index} className="cont-import">
                      <tr>
                        <td>{medicamento.principio_activo.toUpperCase()}</td>
                        <td>{medicamento.nombre_medicamento}</td>
                        <td>{medicamento.concentracion}</td>
                        <td>{medicamento.contenido}</td>
                      </tr>
                    </tbody>
                  ))}
                </Table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
};
